import { render } from "./WeChat.vue?vue&type=template&id=52237b50"
import script from "./WeChat.vue?vue&type=script&lang=js"
export * from "./WeChat.vue?vue&type=script&lang=js"

import "./WeChat.vue?vue&type=style&index=0&id=52237b50&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__